<template>
    <ProSpaceVLayout :gap="10" class="home-dashboard" is-inline-h>
        <ProSpaceHLayout justify-content="space-between">
            <div class="text-size-16 text-bold text-color-main text-ellipsis">
                {{ title }}
            </div>
            <slot name="header" />
        </ProSpaceHLayout>
        <slot name="body" />
    </ProSpaceVLayout>
</template>

<script>
import {
  ProSpaceHLayout,
  ProSpaceVLayout,
} from "@prospace/prospace-components-library";
export default {
    name: "HomeDashboard",
    components: {
        ProSpaceHLayout,
        ProSpaceVLayout,
    },
    props: {
        title: {
            type: String,
            required: true
        },
    },
}
</script>

<style lang="scss">
.home-dashboard {
    padding: 10px;
    margin: 10px 10px 0;
    border-radius: 5px;
    background: var(--prospace-ui-gray-card-bg);
    box-shadow: 0px 4px 4px rgba(119, 119, 119, 0.07);
    width: calc(100% - 20px) !important;
}
</style>
